"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isUserWithContactInfo = void 0;
/** type guard so we can check for TS if user is new or old */
exports.isUserWithContactInfo = function (user) { var _a; return user.loginEmail !== undefined && ((_a = user.data) === null || _a === void 0 ? void 0 : _a.name) !== undefined; };
//# sourceMappingURL=users.js.map